module.exports = __webpack_public_path__ + "img/8m1.c9f7242f.jpg";